{
  "completed": "Pabeigts: ",
  "current": "Pašreizējais: ",
  "notCompleted": "Nav pabeigts: ",
  "steplist": "Darbību saraksts"
}
